module.exports = __webpack_public_path__ + "img/职业技能.850bcca6.jpg";